import {
  concat,
  lensPath,
  view,
  set,
  identity,
  ifElse,
  isEmpty,
  map,
  mergeRight,
  mergeLeft,
  pipe,
  propEq,
} from "ramda";
import { isBlank } from "../common/general";
import * as uploadActions from "./uploadActions";
import * as submissionActions from "submission/submissionActions";
import { validateUpload, validateWorkTypeId } from "./uploadValidation";
import {
  completeStep,
  getErrors,
  initialStepState,
  setCompleted,
  setErrors,
  setField,
  setFields,
  setLoadingLocalStorage,
} from "common/stepReducerCommon";
import * as steps from "../common/steps";

const initialUploadStepState = {
  loadingLocalStorage: false,
  fields: {
    coverFile: {},
    workFiles: [],
  },
};

const initialState = mergeRight(initialStepState, initialUploadStepState);

const coverFileLens = lensPath(["fields", "coverFile"]);
const setCoverFile = set(coverFileLens);
export const getCoverFile = view(coverFileLens);

const workFilesLens = lensPath(["fields", "workFiles"]);
const setWorkFiles = set(workFilesLens);
export const getWorkFiles = view(workFilesLens);

const updateWorkFiles = newFiles => state => {
  const workFiles = isBlank(getWorkFiles(state)) ? [] : getWorkFiles(state);
  return setWorkFiles(concat(newFiles, workFiles), state);
};

// const updateUploadProgess = (workFile, progress, status) => files =>
//   map(
//     ifElse(
//       propEq("name", workFile.name),
//       mergeLeft({ progress, status }),
//       identity
//     )
//   )(files);

const updateUploadProgess = (workFile, progress, status, error) => files =>
  map(
    ifElse(
      propEq("name", workFile.name),
      mergeLeft({ progress, status, error }),
      identity
    )
  )(files);

// const updateWorkFile = (workFile, progress, status) => state => {
//   const workFiles = getWorkFiles(state);
//   const updatedWorkFiles = updateUploadProgess(
//     workFile,
//     progress,
//     status
//   )(workFiles);

//   return setWorkFiles(updatedWorkFiles, state);
// };
const updateWorkFile = (workFile, progress, status, error) => state => {
  const workFiles = getWorkFiles(state);
  const updatedWorkFiles = updateUploadProgess(
    workFile,
    progress,
    status,
    error
  )(workFiles);

  return setWorkFiles(updatedWorkFiles, state);
};

const updateCoverFile = (progress, status) => state => {
  const coverFile = getCoverFile(state);
  const updatedCoverFile = mergeRight(coverFile, { progress, status });

  return setCoverFile(updatedCoverFile, state);
};

const localStorageLoaded = (data, state) =>
  pipe(
    setLoadingLocalStorage(false),
    setField(
      ["workFiles"],
      isEmpty(data) ? initialState.workFiles : data.workFiles
    ),
    setWorkFiles(isEmpty(data) ? initialState.workFiles : data.workFiles),
    setCompleted(isEmpty(data) ? initialState.completed : data.completed)
  )(state);

const cancelSubmission = pipe(
  setCompleted(false),
  setFields(initialState.fields),
  setErrors(initialState.errors)
);

const workTypeFieldBlurred = (workTypeId, state) => {
  // Reset workFiles and coverFile errors on blur
  const errors = mergeRight(getErrors(state), {
    workFiles: null,
    coverFile: null,
  });
  return setErrors(validateWorkTypeId(workTypeId, errors), state);
};

const uploadReducer = (
  state = initialState,
  action,
  submissionState,
  applicationState
) => {
  switch (action.type) {
    case uploadActions.COMPLETE_STEP:
    case submissionActions.SUBMIT:
      return completeStep(validateUpload(submissionState), state);

    case uploadActions.LOCAL_STORAGE_LOADED:
      return localStorageLoaded(action.data, state);

    case uploadActions.SET_COVER_FILE:
      return pipe(setCoverFile(action.file), setCompleted(false))(state);

    case uploadActions.UPDATE_COVER_FILE:
      return pipe(
        updateCoverFile(action.progress, action.status),
        setCompleted(false)
      )(state);

    case uploadActions.SET_WORK_FILES:
      return pipe(setWorkFiles(action.workFiles), setCompleted(false))(state);

    case uploadActions.UPDATE_WORK_FILES:
      return pipe(
        updateWorkFiles(action.workFiles),
        setCompleted(false)
      )(state);

    case uploadActions.UPDATE_WORK_FILE:
      return pipe(
        updateWorkFile(
          action.workFile,
          action.progress,
          action.status,
          action.error
        ),
        setCompleted(false)
      )(state);

    case uploadActions.WORK_TYPE_FIELD_BLURRED:
      return workTypeFieldBlurred(action.workTypeId, state);

    case submissionActions.SET_WORK_TYPE_ID:
      return pipe(setWorkFiles([]), setCompleted(false))(state);

    case submissionActions.ADD_ANOTHER_WORK:
    case submissionActions.CANCEL_SUBMISSION:
      return cancelSubmission(state);

    case submissionActions.SET_ACTIVE_STEP:
      return action.step === steps.FILE_UPLOAD
        ? setCompleted(false)(state)
        : state;

    default:
      return state;
  }
};

export default uploadReducer;
